import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { getMask, rgb2arr } from '@antv/l7-utils';
import BaseModel from "../../core/BaseModel";
import { polygonTriangulation } from "../../core/triangulation";

/* babel-plugin-inline-import '../../shader/minify_picking_frag.glsl' */
var polygon_tile_frag = "uniform float u_opacity : 1.0;\nvarying vec4 v_color;\n\n#pragma include \"picking\"\n\nvoid main() {\n  gl_FragColor = v_color;\n  gl_FragColor.a *= u_opacity;\n  gl_FragColor = filterColor(gl_FragColor);\n}\n";

/* babel-plugin-inline-import '../shaders/tile/polygon_tile_vert.glsl' */
var polygon_tile_vert = "attribute vec4 a_Color;\nattribute vec3 a_Position;\n\nuniform mat4 u_ModelMatrix;\nuniform mat4 u_Mvp;\n\n// uniform vec2 u_tileOrigin;\n// uniform float u_coord;\n\nvarying vec4 v_color;\n\n#pragma include \"projection\"\n#pragma include \"picking\"\n\nvoid main() {\n  v_color = a_Color;\n  vec4 project_pos = project_position(vec4(a_Position, 1.0));\n\n  // if(u_coord > 0.0) {\n    if(u_CoordinateSystem == COORDINATE_SYSTEM_P20_2) { // gaode2.x\n      gl_Position = u_Mvp * (vec4(project_pos.xyz, 1.0));\n    } else {\n      gl_Position = project_common_position_to_clipspace(vec4(project_pos.xyz, 1.0));\n    }\n  // } else {\n  //   vec4 world = vec4(project_mvt_offset_position(vec4(u_tileOrigin, 0.0, 1.0)).xyz, 1.0); // \u74E6\u7247\u8D77\u59CB\u70B9\u7684\u4E16\u754C\u5750\u6807\n\n  //   vec2 pointOffset = a_Position.xy *  pow(2.0, u_Zoom); // \u74E6\u7247\u5185\u7684\u70B9\u7684\u504F\u79FB\u5750\u6807\n    \n  //   world.xy += pointOffset;\n\n  //   if (u_CoordinateSystem == COORDINATE_SYSTEM_METER_OFFSET || u_CoordinateSystem == COORDINATE_SYSTEM_LNGLAT_OFFSET) {\n  //     // Needs to be divided with project_uCommonUnitsPerMeter\n  //     world.w *= u_PixelsPerMeter.z;\n  //   }\n\n  //   gl_Position = u_ViewProjectionMatrix * world + u_ViewportCenterProjection;\n  // }\n\n  setPickingColor(a_PickingColor);\n}\n\n";

/* babel-plugin-inline-import '../../shader/minify_frag.glsl' */
var polygon_tile_map_frag = "uniform float u_opacity : 1.0;\nuniform vec4 u_color;\n\nvoid main() {\n  gl_FragColor = u_color;\n  gl_FragColor.a *= u_opacity;\n}\n";

/* babel-plugin-inline-import '../shaders/tile/polygon_tile_map_vert.glsl' */
var polygon_tile_map_vert = "attribute vec3 a_Position;\n\nuniform mat4 u_ModelMatrix;\nuniform mat4 u_Mvp;\n\n#pragma include \"projection\"\n\nvoid main() {\n  vec4 project_pos = project_position(vec4(a_Position, 1.0));\n\n  if(u_CoordinateSystem == COORDINATE_SYSTEM_P20_2) { // gaode2.x\n    gl_Position = u_Mvp * (vec4(project_pos.xyz, 1.0));\n  } else {\n    gl_Position = project_common_position_to_clipspace(vec4(project_pos.xyz, 1.0));\n  }\n}";

var FillModel = /*#__PURE__*/function (_BaseModel) {
  _inherits(FillModel, _BaseModel);

  var _super = _createSuper(FillModel);

  function FillModel() {
    _classCallCheck(this, FillModel);

    return _super.apply(this, arguments);
  }

  _createClass(FillModel, [{
    key: "getUninforms",
    value: function getUninforms() {
      var _ref = this.layer.getLayerConfig(),
          _ref$opacity = _ref.opacity,
          opacity = _ref$opacity === void 0 ? 1 : _ref$opacity,
          usage = _ref.usage,
          _ref$color = _ref.color,
          color = _ref$color === void 0 ? '#fff' : _ref$color;

      return {
        // u_tileOrigin: tileOrigin || [0, 0],
        // u_coord: coord === 'lnglat' ? 1.0 : 0.0,
        u_opacity: opacity,
        u_color: usage === 'basemap' ? rgb2arr(color) : [0, 0, 0, 0]
      };
    }
  }, {
    key: "initModels",
    value: function initModels(callbackModel) {
      this.buildModels(callbackModel);
    }
  }, {
    key: "buildModels",
    value: function buildModels(callbackModel) {
      var _ref2 = this.layer.getLayerConfig(),
          _ref2$mask = _ref2.mask,
          mask = _ref2$mask === void 0 ? false : _ref2$mask,
          _ref2$maskInside = _ref2.maskInside,
          maskInside = _ref2$maskInside === void 0 ? true : _ref2$maskInside,
          usage = _ref2.usage;

      this.layer.triangulation = polygonTriangulation;
      this.layer.buildLayerModel({
        moduleName: 'polygonTile_' + usage,
        vertexShader: usage === 'basemap' ? polygon_tile_map_vert : polygon_tile_vert,
        fragmentShader: usage === 'basemap' ? polygon_tile_map_frag : polygon_tile_frag,
        triangulation: polygonTriangulation,
        depth: {
          enable: false
        },
        blend: this.getBlend(),
        stencil: getMask(mask, maskInside),
        pick: usage !== 'basemap'
      }).then(function (model) {
        callbackModel([model]);
      }).catch(function (err) {
        console.warn(err);
        callbackModel([]);
      });
    }
  }, {
    key: "clearModels",
    value: function clearModels() {}
  }, {
    key: "registerBuiltinAttributes",
    value: function registerBuiltinAttributes() {//
    }
  }]);

  return FillModel;
}(BaseModel);

export { FillModel as default };